import request from '@/utils/request'

// 乐谱分类平铺列表(含上级名称)
export function listSheetCategory(data) {
  return request({
    url: '/biz/admin/sheet/category/list',
    method: 'post',
    data: data
  })
}

// 乐谱分类二级树
export function treeSheetCategory(data) {
  return request({
    url: '/biz/admin/sheet/category/tree',
    method: 'post',
    data: data
  })
}

// 乐谱分类详情
export function getSheetCategory(data) {
  return request({
    url: '/biz/admin/sheet/category/detail',
    method: 'post',
    data: data
  })
}

// 新增乐谱分类
export function addSheetCategory(data) {
  return request({
    url: '/biz/admin/sheet/category/add',
    method: 'post',
    data: data
  })
}

// 修改乐谱分类
export function updateSheetCategory(data) {
  return request({
    url: '/biz/admin/sheet/category/edit',
    method: 'post',
    data: data
  })
}

// 删除乐谱分类
export function delSheetCategory(data) {
  return request({
    url: '/biz/admin/sheet/category/delete',
    method: 'post',
    data: data
  })
}
